import * as yup from "yup";

export const homeFormSchema = yup.object().shape({
  homeName: yup.string().required("Please enter home name"),
  homeRange: yup.string().required("Please select home range"),
  homeStorey: yup.string().required("Please select home storey"),
});
